<template>
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-12 items-center">
    <div class="bg-white w-fullrounded-lg shadow">
      
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <div class="flex">
          <button :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mr-3" @click="RouterBack()">
            <i class="material-icons">chevron_left</i>
          </button>
          <div class="text-xl font-semibold text-primary-500">
            {{ $t('import_orders') }}
          </div>
        </div>
      </div>

      <div class="px-6 mt-3">
        <div class="grid lg:grid-cols-3 gap-6" v-if="currentUser && currentUser.type">
          
          <div class="border-2 h-10 hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
              <p>
                <label for="seller" class="bg-white text-gray-700 px-1" >
                  Country ({{ $t('warehouse') }})
                  <span :class="$colors.required">*</span></label>
              </p>
            </div>
            <p>
              <v-select @input="setSelectedW" :options="warehousesUser" label="name">
                <template slot="option" slot-scope="option">
                  <img class="flag-img" :src="$f.getCountryCode(option.country)"/>
                  {{ option.name }}
                </template>
              </v-select>
            </p>
          </div>

          <div v-if="currentUser.type != 'Seller'" class="border-2 h-10 hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
              <p>
                <label for="seller" class="bg-white text-gray-700 px-1">
                  {{ $t('select_seller') }}
                  <span :class="$colors.required">*</span></label>
              </p>
            </div>
            <p>
              <v-select label="company" :options="sellers" @input="setSelected"></v-select>
            </p>
          </div>

          <div v-if="currentUser.type != 'Seller'" class="border-2 h-10 hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
              <p>
                <label for="seller" class="bg-white text-gray-700 px-1">
                  Authorized open package
                  <span :class="$colors.required">*</span></label>
              </p>
            </div>
            <p>
              <v-select label="name" v-model="formData.openpackage" :options="autorizes" @input="setSelectedAuthorized"></v-select>
            </p>
          </div>
        </div>
      </div>

      <div class="px-6 mt-3">
        <div class="relative">

          <loading :active.sync="loading" :is-full-page="fullPage"></loading>

          <div class="border border-dashed border-gray-500">
            <input accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @change="processFile($event)" ref="csvOrdersFile" type="file" class="cursor-pointer relative block opacity-0 w-full h-full p-20 z-50"/>
            <div class="text-center p-10 absolute top-0 right-0 left-0 m-auto">
              <h4>{{ $t('drag_file') }}</h4>
              <p v-if="this.selectedFileName" class="font-bold">
                {{ $t('selected_file') }}
                <span class="text-primary-500">{{ this.selectedFileName }}</span>
              </p>
            </div>
          </div>

          <div class="p-5 grid justify-items-center">
            <button @click="uploadOrders" icon="publish" class="flex items-stretch rounded-md mx-1 border border-gray-100 bg-primary-600 hover:bg-primary-600 text-white py-2 px-4 focus:outline-none">
              <i class="self-center material-icons">publish</i>
              {{ $t('upload') }}
            </button>
          </div>
        </div>

        <div v-if="messages.length > 0">
          <table class="min-w-full leading-normal table-messages">
            <thead>
              <tr>
                <th class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                  {{ $t('orderid') }}
                </th>
                
                <th class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                  {{ $t('message') }}
                </th>
              </tr>
            </thead>

            <tbody v-for="(item, index) in messages" :key="index">
              <tr>
                <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                  <div class="text-xs leading-5 capitalize px-2 font-semibold rounded-full text-gray-900">
                    {{ item.orderId }}
                  </div>
                </td>

                <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                  <div :class="item.type" class="text-xs leading-5 capitalize px-2 font-semibold rounded-full text-gray-900">
                    {{ item.text }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- The csv file should be structered like example below: --->
        <button @click="downloadcsvExample" icon="publish" class="flex items-stretch rounded-md mx-1 border border-gray-100 bg-primary-600 hover:bg-primary-600 text-white py-2 px-4 focus:outline-none">
          <i class="self-center material-icons">file_download</i>
          {{ $t('download_xlsx_example') }}
        </button>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
  data() {
    return {
      formData: { warehouse: null },
      messages: [],
      warehouses: [],
      warehousesUser: [],
      sellers: [],
      currentUser: {},
      loading: false,
      fullPage: false,
      selectedFileName: '',
      idWharhouse: '',
      autorizes: [
        { key: 1, name: 'Authorized' },
        { key: 0, name: 'not Authorized' },
      ],
    };
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters['wharhouse/warhouseSelected'];
    },
  },
  watch: {
    warhouseSelected: async function(oldVal, newVal) {
      await this.getwharhouseId();
    },
  },
  async mounted() {
    await this.getCurrentSeller();
    await this.getwharhouseId();
  },
  methods: {
    RouterBack: function() {
      this.$router.back();
    },
    async getWarehouses() {
      const filter = { limit: 1000, is_primary: true };
      const res = await this.$server.search('warehouses', filter);
      if (res.content.results) {
        this.warehouses = res.content.results;
      } else this.warehouses = [];
    },
    async setSelectedW(contry) {
      if (contry) this.formData.warehouse = contry;
      else this.formData.warehouse = null;
    },
    async getwharhouseId() {
      await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
        this.idWharhouse = res;
      });
    },
    setSelected(seller) {
      if (seller) {
        this.formData.seller = seller;
      } else {
        this.formData.seller = null;
      }
    },
    setSelectedAuthorized(value) {
      if (value) this.formData.openpackage = value;
      else this.formData.openpackage = null;
    },
    async save() {},
    async processFile(event) {
      if (event.target.files.length) {
        var reader = new FileReader();
        let ExtensionFile = event.target.files[0].name.split('.').pop();
        
        if (ExtensionFile == 'csv') {
          this.selectedFileName = event.target.files[0].name;
          reader.onload = async e => {
            this.formData.file = e.target.result.split(',')[1];
            this.formData.type = 'Csv';
          };
          reader.readAsDataURL(event.target.files[0]);
        } else {
          reader.onload = e => {
            const bstr = e.target.result;
            this.selectedFileName = event.target.files[0].name;
            const wb = XLSX.read(bstr, { type: 'binary', cellDates: true });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
            this.formData.file = data.filter(function(x) {
              return x.length;
            });
            this.formData.type = 'Excel';
          };
          reader.readAsBinaryString(event.target.files[0]);
        }
      } else {
        this.formData.openpackage = null;
        this.formData.file = '';
        this.selectedFileName = '';
      }
      this.messages = [];
    },
    getElementInArray(data, value) {
      var result = data.filter(function(o) {
        let whar = o.warehouse;
        if (o.warehouse._id) whar = o.warehouse._id;
        return whar == value.toString();
      });
      return result ? result[0] : null;
    },
    async uploadOrders() {
      if (this.formData.file && this.formData.seller && this.formData.warehouse) {
        let dataWhrahouseSetting = null;
        if (this.formData.seller.settings.length > 0) {
          dataWhrahouseSetting = this.getElementInArray(this.formData.seller.settings, this.idWharhouse._id);
        }

        if (!dataWhrahouseSetting ||(dataWhrahouseSetting && !dataWhrahouseSetting.confirmation && !dataWhrahouseSetting.fulfillement && !dataWhrahouseSetting.shipping)) {
          alert("vous n'avait pas activé aucun services veuillez contacter administration vex", 'warning');
          return false;
        }

        if (this.formData.seller.status != 'active') {
          alert( "Cette user n'est pas active contacter vex pour l'activer merci", 'warning');
          return false;
        }

        if (this.currentUser && this.currentUser.type != 'Seller' && !this.formData.openpackage) {
          alert('Authorized open package', 'warning');
          return false;
        }

        this.loading = true;
        this.$insProgress.start();

        const messages = await this.$server.import('orders', this.formData);
        this.loading = false;

        this.$insProgress.finish();
        if (messages && messages.content) {
          alert(this.$t('upload_result'), 'default');
          this.messages = messages.content;

          this.formData.file = '';
          this.selectedFileName = '';

          this.formData.openpackage = null;
        } else
          alert( "Une Erreur S'est Produite, Veuillez Réessayer Plus Tard", 'error');
      } else {
        const isFilePresent = !!this.formData.file;
        const isSellerPresent = !!this.formData.seller;
        const isWarhousePresent = !!this.formData.warehouse;

        let msg = '';
        if (!isFilePresent || !isSellerPresent || !isWarhousePresent) {
          msg = 'please specify ';
          if (!isFilePresent) {
            msg = msg + 'the file';
          }
          if (!isFilePresent && !isSellerPresent) {
            msg = msg + ' and ';
          }
          if (!isSellerPresent) {
            msg = msg + 'the seller';
          }
          if (!isFilePresent && !isWarhousePresent) {
            msg = msg + ' and ';
          }
          if (!isWarhousePresent) {
            msg = msg + 'the warehouse';
          }
        }

        if (!!msg) {
          alert(msg);
        }
      }

      this.$refs.csvOrdersFile.value = null;
    },
    async getCurrentSeller() {
      const res = await this.$server.me('users');
      if (res.content) {
        this.currentUser = res.content;
        await this.getWarehouses();

        if (this.currentUser.type != 'Seller') {
          await this.getSellers();
        } else this.formData.seller = this.currentUser;
        
        this.currentUser.countries.forEach(
          function(country) {
            const obj = this.warehouses.find(x => x.country == country && x.is_primary);
            this.warehousesUser.push(obj);
          }.bind(this),
        );
      }
    },
    async getSellers() {
      const res = await this.$server.search('users', {
        type: 'Seller',
        countries: await this.warhouseSelected,
        limit: 4000,
      });
      if (res.content.results) {
        this.sellers = res.content.results;
      }
    },
    async downloadcsvExample() {
      let link = window.document.createElement('a');
      link.href = 'https://storeino-files.b-cdn.net/edco/9-2022/1664556639740.xls';
      link.download = 'orders_exemple.xls';
      link.click();
    },
    async downloadxlsxExample() {
      var blob = new Blob(
        [
          'ORDER ID,DATE,PRODUCT NAME,CONSTUMER NAME,PHONE NUMBER,ADRESSE,CITY,PRICE,QUANTITY,STORE',
        ],
        {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;',
        },
      );

      var url = window.URL || window.webkitURL;
      let link = url.createObjectURL(blob);

      var a = document.createElement('a');
      a.setAttribute('download', 'orders_example.xlsx');

      a.setAttribute('href', link);
      document.body.appendChild(a);
      
      a.click();
      document.body.removeChild(a);
    },
  },
};
</script>

<style>
.table-messages {
  display: block;
  max-height: 500px;
  overflow: auto;
}
.error {
  color: #c62525;
}
.success {
  color: #25c631;
}
.warn {
  color: #ff9800;
}
</style>
